import { Address } from "@opendaw/lib-box";
export class ParameterFieldAdapters {
    #set;
    constructor() {
        this.#set = Address.newSet(adapter => adapter.field.address);
    }
    register(adapter) {
        this.#set.add(adapter);
        return { terminate: () => this.#set.removeByValue(adapter) };
    }
    get(address) { return this.#set.get(address); }
    opt(address) { return this.#set.opt(address); }
}
